import { createGlobalStyle, default as styled } from 'styled-components';

import { DESKTOP_PADDING_Y, MOBILE_PADDING_Y, WRAPPER_MAX_WIDTH } from './variables';

import { BlobImage as BlobImageAtom } from '@/atoms/BlobImage/BlobImage';
import { fadeIn, transitionDuration } from '@/styles/helpers';

/*
Global style
*/

export const GlobalStyle = createGlobalStyle`
  body { 
    background-color: ${(p) => p.theme.colors.slateGray[10]};
    
    /* needed for @dot components */
    font-family: 'Montserrat';
  }
  
  #root {
    width: 100%; /* NOTE: fix for modal - modal adds position:fixed to #root element, which breaks layout without width set to 100% */
  }
`;

/*
Shared components
*/

export const PageWrapper = styled.div`
  max-width: ${WRAPPER_MAX_WIDTH}px;
  margin: 0 auto;

  padding: 0 ${MOBILE_PADDING_Y}px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    padding: 0 ${DESKTOP_PADDING_Y}px;
  }
`;

export const CaptureContainer = styled.div`
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  max-width: 970px;
  isolation: isolate;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    border-radius: 12px;
    margin: 30px auto 0 auto;
  }
`;

export const FadeInContainer = styled.div`
  animation: ${fadeIn} ${transitionDuration.semiFast} ease-in-out forwards;
`;

export const InfoContainer = styled(CaptureContainer)`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    margin: 0 auto;
  }
`;

export const DarkOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const BlobImage = styled(BlobImageAtom)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

/*
Utility components
*/

export const RelativeContainer = styled.div`
  position: relative;
`;
